const failSafe = (callback: () => any) => {
  try {
    return callback();
  } catch (e) {
    return false;
  }
};

export default {
  getItem: (key: string): string | null => (
    failSafe(() => window.localStorage?.getItem(key)) || null
  ),
  setItem: (key: string, value: string | null): void => (
    failSafe(() => window.localStorage?.setItem(key, value)) || undefined
  ),
  removeItem: (key: string): void => (
    failSafe(() => window.localStorage?.removeItem(key)) || undefined
  ),
};
